// extracted by mini-css-extract-plugin
export default {"DocumentActionsContainer":"_DocumentActionsContainer--gsq0u","Open":"_Open--TcYr5","DocumentActionsTrigger":"_DocumentActionsTrigger--CHC74","Icon":"_Icon--x1CqB"};